import { render, staticRenderFns } from "./ResumenEquipo.vue?vue&type=template&id=40b55ee5&scoped=true&"
import script from "./ResumenEquipo.vue?vue&type=script&lang=js&"
export * from "./ResumenEquipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b55ee5",
  null
  
)

export default component.exports